export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13278.1aacdd30.jpg";